import { SmartFeedEngine as FrameworkSmartFeedEngine } from "@bloglovin/vue-framework";
export default class SmartFeedEngine extends FrameworkSmartFeedEngine {

  async getResolvedStoreImport(filePath) {
    return import(`@studio/StoriesEditor/smart-feed/${filePath}`);
  }

  async getResolvedLayoutComponent(filePath) {
    return import(`@studio/StoriesEditor/smart-feed/${filePath}`);
  }
}
